import app from '@/app';
import templateUrl from './navbar.html';

/* @ngInject */
function Controller($scope, $state, Auth, Principal, LoginService, $http, $interval, $translate, JhiLanguageService, $rootScope) {
	var $ctrl = this;

	$ctrl.isNavbarCollapsed = true;
	$ctrl.isAuthenticated = Principal.isAuthenticated;

	// Hardcoded instance guard: some modules are only released for the contracted
	// domains (same rule used to show the "Sincronizar Kartado" button in asBuilt).
	$ctrl.currentAccount = null;
	$ctrl.isInstance = isInstance;

	$scope.$on('authenticationSuccess', loadAccount);
	loadAccount();

	function loadAccount() {
		Principal.identity().then(function(account) {
			$ctrl.currentAccount = account;
		});
	}

	// Accepts a comma-separated list, mirroring the has-authority syntax.
	function isInstance(domains) {
		var baseUrl = $ctrl.currentAccount && $ctrl.currentAccount.baseUrl;
		if (!baseUrl) {
			return false;
		}
		var current = baseUrl.replace(/\/+$/, '');
		return domains.split(',').some(function(domain) {
			return current === 'https://' + domain.trim();
		});
	}

	$ctrl.login = login;
	$ctrl.logout = logout;
	$ctrl.toggleNavbar = toggleNavbar;
	$ctrl.collapseNavbar = collapseNavbar;
	$ctrl.$state = $state;

	$ctrl.languages = null;
	$ctrl.currentLanguage = null;

	JhiLanguageService.getAll().then(function(languages) {
		$ctrl.languages = languages;
	});

	JhiLanguageService.getCurrent().then(function(language) {
		$ctrl.currentLanguage = language;
	});

	$ctrl.changeLanguage = function(languageKey) {
		JhiLanguageService.changeLanguage(languageKey);
		$ctrl.currentLanguage = languageKey;
	};

	$ctrl.processingItems = [];
	$ctrl.isLoading = false;
	$ctrl.showDropdown = false;
	$ctrl.searchQuery = '';
	$ctrl.page = 0;
	$ctrl.hasNextPage = false;

	var aPI_ENDPOINT = '/api/plans/status';
	// Monotonic counter: responses whose gen < fetchGeneration are discarded.
	var fetchGeneration = 0;

	function doFetch(page, append) {
		if (!Principal.isAuthenticated()) {
			$ctrl.processingItems = [];
			return;
		}

		// Each call gets a unique generation stamp.
		var gen = ++fetchGeneration;
		$ctrl.isLoading = true;

		var params = { page: page, size: 5, sort: 'id,desc', t: new Date().getTime() };

		$http.get(aPI_ENDPOINT, { params: params })
			.then(function(response) {
				// Discard if a newer request (search or poll) already superseded this one.
				if (gen !== fetchGeneration) return;

				var pageData = response.data || {};
				var items = pageData.content || [];
				// Pre-compute the display text (translated module + name) for client-side filtering.
				items.forEach(function(item) {
					item.displayText = ($translate.instant('name.plan.type.' + item.module) + ' ' + item.name).toLowerCase();
				});
				$ctrl.processingItems = append
					? $ctrl.processingItems.concat(items)
					: items;
				$ctrl.hasNextPage = !pageData.last;
			})
			.catch(function(error) {
				if (gen !== fetchGeneration) return;
				if (error.status <= 0) {
					console.error('Backend is unreachable (Offline).');
				} else {
					console.error('Error fetching processing status:', error);
				}
				if (!append) {
					$ctrl.processingItems = [];
					$ctrl.hasNextPage = false;
				}
			})
			.finally(function() {
				// Only clear the flag for the generation that actually owns it.
				if (gen === fetchGeneration) $ctrl.isLoading = false;
			});
	}

	$ctrl.loadMore = function() {
		$ctrl.page += 1;
		doFetch($ctrl.page, true);
	};


	$ctrl.matchesSearch = function(item) {
		if (!$ctrl.searchQuery) return true;
		return item.displayText && item.displayText.indexOf($ctrl.searchQuery.toLowerCase()) >= 0;
	};

	$ctrl.toggleDropdown = function() {
		$ctrl.showDropdown = !$ctrl.showDropdown;
	};

	// Polling: skip silently while the user has loaded additional pages to
	// avoid collapsing a manually expanded list back to page 0.
	$interval(function() {
		if ($ctrl.page > 0) return;
		doFetch(0, false);
	}, 5000);

	$rootScope.$on('processStatusChanged', function() {
		if ($ctrl.page > 0) return;
		doFetch(0, false);
	});

	doFetch(0, false);

	function login() {
		collapseNavbar();
		LoginService.open();
	}

	async function logout() {
		collapseNavbar();
		await Auth.logout();
		$state.go('home');
	}

	function toggleNavbar() {
		$ctrl.isNavbarCollapsed = !$ctrl.isNavbarCollapsed;
	}

	function collapseNavbar() {
		$ctrl.isNavbarCollapsed = true;
	}
}

app.component('prNavbar', { templateUrl, controller: Controller });
